const GERMAN_TRANSLITERATION = {
    ä: 'ae',
    ö: 'oe',
    ü: 'ue',
    ß: 'ss',
    Ä: 'Ae',
    Ö: 'Oe',
    Ü: 'Ue'
};
// The German table runs before NFD: NFD would reduce `ä` to `a`, and `ß` would become a hyphen.
export function slugify(input) {
    return input.replace(/[äöüßÄÖÜ]/g, (ch)=>GERMAN_TRANSLITERATION[ch]).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

//# sourceMappingURL=slugify.js.map